// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 354 ? "ready-app" : chunkId) + "." + {"25":"7033395f","354":"81628a1b"}[chunkId] + ".chunk.js";
};